import { render, staticRenderFns } from "./AzureOidc.vue?vue&type=template&id=070d77c4"
import script from "./AzureOidc.vue?vue&type=script&lang=js"
export * from "./AzureOidc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports